import * as $ from "jquery";
import CartService from "../Components/components.cart";
import CurrencyService from "../Services/service.currency";
import Handlebars from "Handlebars";
import DeliveryAddressComponent from "./components.deliveryaddress";
import CustomersComponent from "../Components/components.customers";


export default class SearchComponent {
    constructor() {
        this.componentSelector = "#product-search";
        this.instance = this;
        this.debounceTimer = null;
        this.lastQuery = "";
        this.cart = new CartService();
        this.lastHash = "";
        this.currencyFormatter = new CurrencyService();
        this.cartTemplateSelector = "#checkout-cart-template";
        this.cartErrorsTemplateSelector = "#checkout-carterrors-template";
        this.cartResultSelector = "#checkout-cart";
        this.cartErrorsSelector = "#checkout-cart-errors";
        this.searchResultTemplate;
        this.cartErrorsTemplate;
        this.shippingTemplate;
        this.checkoutModel;
        this.IsWebSearch = false;
        this.deliveryAddress = new DeliveryAddressComponent();
        this.deliveryAddress.modalSelector = '#checkout-address-modal-content';
        this.enableMultipleDeliveryAddresses = $('.checkout-page').data('usenewdeliveryaddress');
        this.nshiftStale = true;
        this.nshiftWidgetFresh = false;
    }

    init() {
        let instance = this;
        if ($(instance.componentSelector).length > 0) {
            instance.bind();
            instance.deliveryAddress.init();

            const cartTemplate = $(this.cartTemplateSelector).html();
            const cartErrorsTemplate = $(this.cartErrorsTemplateSelector).html();
            if (cartTemplate !== undefined) {
                this.searchResultTemplate = Handlebars.compile(cartTemplate);
            }
            if (cartErrorsTemplate !== undefined) {
                this.cartErrorsTemplate = Handlebars.compile(cartErrorsTemplate);
            }
        }

        if (instance.enableMultipleDeliveryAddresses == "False") {
            window._briqpay.subscribe('addressupdate', function (data) {
                $('.checkout-page').attr('data-zip', data.shippingaddress.zip);
                instance.nshiftStale = true;
                instance.nshiftWidgetFresh = false;
                instance.updatePaymentButtons(instance);
                instance.updateNShift(instance.checkoutModel, instance)
            });
        }
   
        $('#query1').focus();

        this.setupSearchMode();
    }

    bind() {
        let instance = this;

        $('#query2').off().on('keyup', function () {
            clearTimeout(instance.debounceTimer);
            instance.debounceTimer = setTimeout(function () {
                instance.search(instance, 1);
            }, 850);
        });

        $('#query3').off().on('keyup', async function () {
            clearTimeout(instance.debounceTimer);
            instance.debounceTimer = setTimeout(async function () {
                await instance.webbsearch(instance, 0);
            }, 850);
        });

        $('#cart').on('mouseenter', function () {
            $(this).addClass('active');
        });

        $('#cart').on('mouseleave', function () {
            $(this).removeClass('active');
        });

        this.cart.cart(instance.showCart, instance);
    }

        setupSearchMode() {
        const instance = this;
        const $q1 = $('#query1');
        const $q2 = $('#query2');
        const $q3 = $('#query3');

        function activateInternalSearch() {
            $q1.removeClass('search-disabled').addClass('search-active').prop('readonly', false);
            $q2.removeClass('search-disabled').addClass('search-active').prop('readonly', false);

            $q3.removeClass('search-active').addClass('search-disabled').prop('readonly', true);
        }

        function activateWebSearch() {
            $q3.removeClass('search-disabled').addClass('search-active').prop('readonly', false);

            $q1.removeClass('search-active').addClass('search-disabled').prop('readonly', true);
            $q2.removeClass('search-active').addClass('search-disabled').prop('readonly', true);
        }

        $q1.on('focus', activateInternalSearch);
        $q2.on('focus', activateInternalSearch);

        $q3.on('focus', activateWebSearch);

        activateInternalSearch();
    }


    bindCart(instance) {
        $('.js-cart-quantity').off().on('blur', function () {
            instance.validateQuantity(this);
            instance.changeQuantity(this, instance);
        });

        $('.js-cart-quantity').on('keypress', function (e) {
            if (e.which == 13) {
                instance.validateQuantity(this);
                instance.changeQuantity(this, instance);
            }
        });

        $('.js-cart-quantity-increase').off().on('click', function () {
            instance.increase(this);
            instance.changeQuantity(this, instance);
        });

        $('.js-cart-quantity-decrease').off().on('click', function () {
            instance.decrease(this);
            instance.changeQuantity(this, instance);
        });

        $('.js-cart-quantity-remove').off().on('click', function () {
            instance.removeLine(this, instance);
        });

        $('#cart-pay-by-link').off().on('click', function () {
            instance.payByLink(instance);
        });

        $('#cart-pay-by-invoice').off().on('click', function () {
            instance.payByInvoice(instance);
        });

        $('#cart-calculate-shipping, .btn-recalculate-shipping').off().on('click', function () {
            instance.updateNShift(instance.checkoutModel, instance);
        });

        instance.updatePaymentButtons(instance);

        $('.js-add-rebate-row').off().on('click', function () {
            var sku = $(this).attr('data-sku');
            var max = $(this).attr('data-max');
            var qty = $(this).parent().parent().find('.js-cart-quantity').attr('data-quantity');
            instance.addRebateRow(instance, sku, qty, this, max);
        });

        $('#checkout-promocode').off().on('blur', function () {
            instance.updatePromoCode(instance);
        });

        $('#checkout-promocode').on('keypress', function (e) {
            if (e.which == 13) {
                instance.updatePromoCode(instance);
            }
        });

        $(document).on('click', '.js-open-add-address', function () {
            const customerNumber = $(this).attr('data-customer');
            const marketId = $(this).attr('data-marketid');
            const customerId = $(this).attr('data-customerid');
            instance.deliveryAddress.showRadioButtons = true;
            instance.deliveryAddress.openEditModal(customerNumber, marketId, null, customerId);
            $('#checkout-address-modal').show();
        });

        $(document).on('click', '.js-open-checkout-address-modal', function () {
            const customerNumber = $(this).attr('data-customer');
            const marketId = $(this).attr('data-marketid');
            instance.deliveryAddress.showRadioButtons = true;
            instance.deliveryAddress.loadAddressModal(customerNumber, marketId, true);
            $('#checkout-address-modal').show();
        });

        $(document).on('click', '.js-close-address-modal, .js-close.js-close-modal', function () {
            instance.deliveryAddress.showRadioButtons = false;
            $('#checkout-address-modal').hide();
        });

        $(document).on('click', '.js-close-edit-modal', function () {
            instance.deliveryAddress.loadAddressModal(
                instance.deliveryAddress.currentCustomerNumber,
                instance.deliveryAddress.currentMarketId
            );
        });

        $(document).on('click', function (e) {
            if (!$(e.target).closest('#checkout-address-modal-content').length &&
                !$(e.target).closest('.js-open-checkout-address-modal').length &&
                !$(e.target).closest('.js-open-add-address').length) {
                instance.deliveryAddress.showRadioButtons = false;
                $('#checkout-address-modal').hide();
            }
        });
        $(document).off('change', '#same-as-billing').on('change', '#same-as-billing', function () {
            instance.saveSelectedAddress(instance, this.checked);
        });

        $(document).off('click', '.js-select-order-address').on('click', '.js-select-order-address', function () {
            instance.saveSelectedAddress(instance);
        });

        $(document).off('click', '.js-set-default-address').on('click', '.js-set-default-address', function () {
            const addressId = $(this).parent().attr('data-addressId');
            const customerNumber = $(this).parent().attr('data-customer');
            const marketId = $(this).parent().attr('data-marketid');
            instance.setDefaultAddress(addressId, customerNumber, marketId, instance);
        });

        $('.js-cart-empty-cart').off().on('click', function () {
            instance.cart.emptyCart(instance.showCart, instance);
        });
    }

    saveSelectedAddress(instance, useInvoiceAddress = false) {
        let addressId = $('input[name="shipping-address"]:checked').val();
        let addressZip = $('input[name="shipping-address"]:checked').attr("data-addr-zip");

        if (useInvoiceAddress) {
            addressId = -1;
            addressZip = $('.invoice-address__zip').attr("data-invoicezip");
            $('.js-add-address').hide()
        } else if (addressZip == undefined) {
            $('#selected-zip').attr('data-zip', '');
            $('.js-add-address').show()
            instance.nshiftStale = true;
            instance.nshiftWidgetFresh = false;
            instance.updatePaymentButtons(instance);
            instance.updateNShift(instance.checkoutModel, instance);
            return;
        } else {
            $('.js-add-address').show()
        }

        axios({
            method: 'post',
            url: "/cart/SetSelectedDeliveryAddress",
            data: { addressId: addressId }
        }).then(function (response) {
            console.log(response.data)
            instance.updateAddressAndShipping(response.data, addressZip, instance, useInvoiceAddress);
            $('.js-save-edit-address').prop('disabled', false).text('Spara');
            $('#checkout-address-modal').hide();
        }).catch(function () { });
    }

    updateAddressAndShipping(html, zip, instance, useInvoiceAddress = false) {
        if (!useInvoiceAddress) {
            $('.delivery-address').replaceWith(html);
        }
        $('#selected-zip').attr('data-zip', zip);
        instance.nshiftStale = true;
        instance.nshiftWidgetFresh = false;
        instance.updatePaymentButtons(instance);
        instance.updateNShift(instance.checkoutModel, instance);
    }

    setDefaultAddress(addressId, customerNumber, marketId, instance) {
        axios({
            method: 'post',
            url: "/address/SetAsDefaultAddress",
            data: { addressId: addressId, customerNumber: customerNumber, marketId: marketId }
        }).then(function (response) {
            if (response.data) {
                $.get("/address/AddressModal", { customerNumber: customerNumber, marketId: marketId, showRadioButtons: true }, function (html) {
                    $('#checkout-address-modal-content').html(html);
                    $('#checkout-address-modal').show();
                });
            }
        }).catch(function (response) {
            console.log(response);
        });
    }

    addSkuWatch(instance, sku, el) {
        axios({
            method: 'post',
            url: "/productsearch/AddNewStockNotification",
            data: { sku: sku }
        }).then(function (response) {
            if (response.data.toLowerCase() == "true") {
                $(el).hide()
                $(el).parent().find('.remove-skuwatch').show();
            }
            else {
                bootbox.alert("Ett fel inträffade.");
            }
        }).catch(function (response) {
            console.log(response);
        });
    }

    removeSkuWatch(instance, sku, el) {
        axios({
            method: 'post',
            url: "/productsearch/CancelStockNotification",
            data: { sku: sku }
        }).then(function (response) {
            if (response.data.toLowerCase() == "true") {
                $(el).parent().hide()
                $(el).parent().parent().find('.js-add-skuwatch').show();
            }
            else {
                bootbox.alert("Ett fel inträffade.");
            }
        }).catch(function (response) {
            console.log(response);
        });
    }

    updatePromoCode(instance) {
        var currentValue = $('#checkout-promocode').attr('data-value');
        var newValue = $('#checkout-promocode').val();

        if (currentValue != newValue) {

            instance.lockCheckout();
            axios({
                method: 'post',
                url: "/cart/updatepromocode",
                data: { code: newValue }
            }).then(function (response) {
                console.log(response.data);
                if (response.data) {
                    instance.cart.cart(instance.showCart, instance);
                    if (response.data == "true")
                        $('.promotion-code-wrapper').addClass("active");
                    else
                        $('.promotion-code-wrapper').removeClass("active");

                } else {
                    instance.unlockCheckout();
                    $('.promotion-code-wrapper').removeClass("active");
                }
            }).catch(function (response) {
                console.log(response);
            });

            $('#checkout-promocode').attr('data-value', newValue);
        }
    }

    addRebateRow(instance, sku, qty, el, max) {
        bootbox.prompt({
            title: "Lägg till rabattrad",
            message: "Ange antal procent i rabatt (max " + max + "%)" ,
            inputType: 'number',
            min: 0,
            max: max,
            callback: function (result) {
                if (result != null) {
                    if (parseInt(result) > 100)
                        result = 100;

                    instance.lockCheckout();
                    var rebateSku = sku + "_" + result + "_B";
                    instance.addToCart(rebateSku, qty, instance, true);

                    var currentLine = $(el).parent().parent().find('.js-cart-quantity-remove');

                    $(el).parent().parent().css('opacity', '0.4');
                    instance.removeLine($(currentLine), instance);
                }
            }
        });
    }

    updatePaymentButtons(instance) {
        const zipEmpty = !$('#selected-zip').attr('data-zip');
        const addressMissing = instance.enableMultipleDeliveryAddresses == "True" && zipEmpty;
        const nshiftEnabled = $('.checkout-page').data('usenshift') == "True";
        const nshiftIsStale = nshiftEnabled && instance.nshiftStale;
        const nshiftWidgetBlocked = nshiftEnabled && !instance.nshiftWidgetFresh;

        $('#cart-pay-by-link, #cart-pay-by-invoice').prop('disabled', addressMissing || nshiftIsStale);
        $('.js-nshift-stale-warning').toggle(nshiftIsStale);
        $('#checkout-nshift').toggleClass('checkout-nshift--disabled', nshiftWidgetBlocked);
    }

    payByLink(instance) {
        var email = $('#paybylink-email').val();
        bootbox.confirm({
            message: "<h3>Skicka betallänk?</h3> <p>Är du säker på att du vill skicka en betallänk till följande e-postadress?</p> <p><b>" + email + "</b> </p>",
            buttons: {
                confirm: {
                    label: 'Ja, skicka',
                    className: 'btn-lg btn-pink'
                },
                cancel: {
                    label: 'Nej',
                    className: 'btn-lg'
                }
            },
            callback: function (result) {
                if (result) {
                    instance.confirmPayByLink(instance);
                }
                console.log('This was logged in the callback: ' + result);
            }
        });
    }

    payByInvoice(instance) {
        $('#briqpay').html("");
        var dontSendReceipt = $('#invoice-no-receipt').prop('checked');

        axios({
            method: 'post',
            url: "/cart/briqpay",
            data: { dontSendReceipt: dontSendReceipt }
        }).then(function (response) {
            $('#briqpay').html(response.data);
        }).catch(function (response) {
        });
    }

    confirmPayByLink(instance) {
        var method = "email";
        var email = $('#paybylink-email').val();
        var phone = "";

        axios({
            method: 'post',
            url: "/cart/paybylink",
            data: { method: method, email: email, phone: phone }
        }).then(function (response) {
            instance.callbackPayByLink(response.data);
        }).catch(function (response) {
        });
    }

    callbackPayByLink(result) {
        var email = $('#paybylink-email').val();
        console.log(result);

        if (result == "true") {
            bootbox.confirm({
                message: "<h3>Betallänk skickad</h3> <p>Betallänk skickad till följande e-postadress:</p> <p><b>" + email + "</b> </p> <p>Kunden kan nu betala ordern själv. Välj Avsluta för att välja en ny kund eller Fortsätt för att ha sessionen kvar.</p>",
                buttons: {
                    confirm: {
                        label: 'Avsluta',
                        className: 'btn-lg btn-pink'
                    },
                    cancel: {
                        label: 'Fortsätt med kunden',
                        className: 'btn-lg'
                    }
                },
                callback: function (result) {
                    if (result) {
                        window.location.href = '/Customers?reset=1';
                    }
                    console.log('This was logged in the callback: ' + result);
                }
            });
        }
    }

    addToCart(sku, quantity, instance, isRebateRow) {
        var marketId = $('#cart').attr('data-marketid');
        instance.cart.add(sku, quantity, marketId, instance.showCart, instance, isRebateRow);
    }

    validateQuantity(el) {
        let quantity = $(el).val();
        if (!$.isNumeric(quantity)) {
            $(el).val(1);
        }

        if (parseInt($(el).val()) < 1) {
            $(el).val(1);
        }
    }

    increase(el) {
        let field = $(el).parent().find('.js-cart-quantity');
        let quantity = $(field).val();

        if (!$.isNumeric(quantity)) {
            quantity = 0;
        }

        if (parseInt(quantity) > 99) {
            return;
        }

        quantity++;
        $(field).val(quantity);
    }

    decrease(el) {
        let field = $(el).parent().find('.js-cart-quantity');
        let quantity = $(field).val();

        if (!$.isNumeric(quantity)) {
            quantity = 2;
        }

        if (parseInt(quantity) < 2) {
            return;
        }

        quantity--;
        $(field).val(quantity);
    }

    changeNShiftShipping(result, instance) {
        let serviceId = $(`[data-id=${result.selectedOptionId}]`).attr('data-serviceId')

        if (serviceId != null) {
            axios({
                method: 'post',
                url: "/cart/updatenshiftshipping",
                data: { serviceId: serviceId, agentId: result.agent, price: result.price, fields: result.fields }
            }).then(function (response) {
                instance.nshiftStale = false;
                instance.showCartSummary(response.data, instance, false);
            }).catch(function (response) {
                console.log(response);
            });
        }
    }

    removeLine(el, instance) {
        let quantity = $(el).attr('data-quantity');
        let sku = $(el).attr('data-sku');
        instance.lockCheckout();
        instance.addToCart(sku, 0 - quantity, instance);
    }

    lockCheckout() {
        $('.checkout-cart').addClass('locked');
        $('.checkout-shipping-methods').addClass('locked');
        //$('#briqpay').addClass('locked');

        var loader = '<div class="loader"></div>';
        $('#briqpay').html(loader);
    }

    unlockCheckout() {
        $('.checkout-cart').removeClass('locked');
        $('.checkout-shipping-methods').removeClass('locked');
        //$('#briqpay').removeClass('locked');
    }

    changeQuantity(el, instance) {
        let field = $(el).parent().find('.js-cart-quantity');
        let currentQuantity = $(field).attr('data-quantity');
        let sku = $(field).attr('data-sku');
        let newQuantity = $(field).val();

        if (currentQuantity != newQuantity) {
            var delta = newQuantity - currentQuantity;
            instance.lockCheckout();

            instance.addToCart(sku, delta, instance);
        }
    }

    search(instance, page) {
        var query1 = $('#query1').val();
        var query2 = $('#query2').val();
        var language = $('body').attr('data-lang');
        var hash = new Date().getTime();
        instance.lastHash = hash.toString();

        //Avoid repeating similar queries
        var queryKey = query1 + query2;
        if (instance.lastQuery == queryKey)
            return;
        instance.lastQuery = query1 + query2 + page;

        this.IsWebSearch = false;

        axios({
            method: 'post',
            url: "/productsearch/search",
            data: { query1: query1, query2: query2, language: language, hash: hash, page: page }
        }).then(function (response) {
            instance.render(response.data, instance, page);
        }).catch(function (response) {
            console.log(response);
        });
    }


    async webbsearch(instance, page2) {
        var query = $('#query3').val();
        var language = $('body').attr('data-lang');

        this.IsWebSearch = true;

        try {
            const response = await axios({
                method: 'post',
                url: "/productsearch/webbsearch",
                data: { query: query, language: language, page: page2 }
            });

            instance.render(response.data, instance, page2);
        } catch (error) {
            console.log(error);
        }
    }

    render(data, instance, page) {
        const isFirstPage = page <= 1;

        if (!instance.IsWebSearch && isFirstPage) {
            var html = $.parseHTML(data);
            var resultHash = $(html)[1].attributes[1].nodeValue.toString();

            if (instance.lastHash !== resultHash) {
                console.log("Hash mismatch - discarded result");
                return;
            }
        }

        if (isFirstPage) {
            $('#result').html(data);
        } else {
            $('.table-paginate-spinner').remove();
            $('#result tbody').append(data);
        }

        var total = $('.table.search-result').attr('data-total');

        if (instance.IsWebSearch) {
            $('.websearch-result--total').html("Hittade " + total + " artiklar från webbsök");
            $('.search-result--total').html("");
        } else {
            $('.search-result--total').html("Hittade " + total + " artiklar");
            $('.websearch-result--total').html("");
        }

        instance.currencyFormatter.formatNumber();

        $('.skuwatch').each(function () {
            if ($(this).attr('data-savedforrequest').toLowerCase() === "true") {
                $(this).find(".remove-skuwatch").show();
            }
            else {
                $(this).find(".js-add-skuwatch").show();
            }
        })        

        $('.js-search-paginate').off().on('click', function () {
            var page = parseInt($('.js-search-paginate').attr('data-page')) + 1;
            instance.search(instance, page);
        })

        $('#result').off().on('scroll', function () {
            if ($(this).scrollTop() + $(this).innerHeight() >= ($(this)[0].scrollHeight) - 10) {
                if ($('#result .js-search-paginate').length) {
                    var page = parseInt($('.js-search-paginate').attr('data-page')) + 1;
                    $('#result .table-paginate-row').remove();

                    if (instance.IsWebSearch) {
                        instance.webbsearch(instance, page)
                    } else {
                        instance.search(instance, page);
                    }
                }
            }
        })

        $('.js-cart').off().on('click', function () {
            var el = $(this).parent().parent().find('.js-quantity');
            var sku = $(el).attr('data-sku');
            var qty = $(el).val();
            var marketId = $('#cart').attr('data-marketid');
            instance.lockCheckout();
            instance.cart.add(sku, qty, marketId, instance.showCart, instance);
        });

        $('.js-cart-bb').off().on('click', function () {
            var el = $(this).parent().parent().find('.js-quantity');
            var sku = $(el).attr('data-sku');
            var qty = $(el).val();
            var marketId = $('#cart').attr('data-marketid');

            instance.lockCheckout();
            sku = sku + "_50_BB";
            instance.cart.add(sku, qty, marketId, instance.showCart, instance);
        });

        $('.js-cart-ab').off().on('click', function () {
            var el = $(this).parent().parent().find('.js-quantity');
            var sku = $(el).attr('data-sku');
            var qty = $(el).val();
            var marketId = $('#cart').attr('data-marketid');

            instance.lockCheckout();
            sku = sku + "_100_AB";
            instance.cart.add(sku, qty, marketId, instance.showCart, instance);
        });

        $('.js-quantity').off().on('keyup', function (e) {
            if (e.which == 13) {
                var el = $(this);
                var sku = $(el).attr('data-sku');
                var qty = $(el).val();
                var marketId = $('#cart').attr('data-marketid');

                instance.lockCheckout();
                instance.cart.add(sku, qty, marketId, instance.showCart, instance);
                $('#query2').focus();
                $('#query2').select();
            }
        });

        $('.js-add-skuwatch').off().on('click', function () {
            var sku = $(this).attr('data-sku');
            instance.addSkuWatch(instance, sku, this);
        });

        $('.js-remove-skuwatch').off().on('click', function () {
            var sku = $(this).attr('data-sku');
            instance.removeSkuWatch(instance, sku, this);
        });
    }

    showCart(data, instance) {
        var checkout = JSON.parse(data);

        instance.checkoutModel = checkout;
        $.each(checkout.PromoItems, function () {
            this.SkuDisplay = this.Sku.substr(0, this.Sku.length - 1);
        });

        $.each(checkout.RebateItems, function () {
            this.SkuDisplay = this.Sku.substr(0, this.Sku.indexOf("_"));

            this.RebateType = "Kundtjänstrabatt";
            if (this.Sku.indexOf("_BB") > 0)
                this.RebateType = "Backbar";

            if (this.Sku.indexOf("_AB") > 0)
                this.RebateType = "Arbetsprodukt";
        });

        console.log(checkout);

        $(instance.cartResultSelector).html(instance.searchResultTemplate(checkout));
        if (checkout.CartOnlyContainsCourses) {
            $('.checkout-nshift-wrapper').hide()
        } else {
            $('.checkout-nshift-wrapper').show()
        }
        if (checkout.CartItemErrors != null) {
            if (checkout.CartItemErrors.length > 0 && instance.cartErrorsTemplate) {
                $(instance.cartErrorsSelector).html(instance.cartErrorsTemplate(checkout));
                $('.checkout-cart-errors').show();
            }
            else {
                $('.checkout-cart-errors').hide();
            }
        }

        $('#cart-total').html(checkout.TotalCostExVAT);
        $('#cart-total').removeClass('formatted');

        $('#cart-freight-free').html(checkout.FreightFeeNeeded);
        $('#cart-freight-free').removeClass('formatted');

        if (checkout.FreightFeeExpressNeeded > -1) {
            $('#cart-freight-fee-express-wrapper').show();
            $('#cart-freight-free-express').html(checkout.FreightFeeExpressNeeded);
            $('#cart-freight-free-express').removeClass('formatted');
        } else {
            $('#cart-freight-fee-express-wrapper').hide();
        }

        if (!$('.cart').hasClass('active')) {
            $('.cart').addClass('flash');
        }

        setTimeout(instance.deactivateCart, 1000);

        instance.updateDiscounts(checkout, instance);

        instance.currencyFormatter.formatNumber();

        instance.bindCart(instance);

        instance.unlockCheckout();

        let nshift = $('.checkout-page').data('usenshift');
        if (nshift == "True") {
            instance.nshiftStale = true;
            instance.nshiftWidgetFresh = false;
            instance.updatePaymentButtons(instance);
        }

        if (checkout.HasError) {
            bootbox.alert({
                title: "Ett problem uppstod",
                message: checkout.ErrorMessage
            });
        }

        if (checkout.CartItemErrors.length) {
            bootbox.alert({
                title: "Ett problem uppstod",
                message: checkout.CartItemErrors[0].Error
            });
        }
    }

    updateDiscounts(data, instance) {
        $('#active-user-customer-discount-money').html(data.TotalCustomerDiscountsMoney);
        $('#active-user-customer-discount-percentage').html(data.TotalCustomerDiscountsPercentage + "%");
        $('#active-user-total-discount-percentage').html(data.TotalDiscountsPercentage + "%");
        $('#active-user-total-discount-money').html(data.TotalDiscountsMoney);

        $('.active-user-wrapper .formatted').removeClass('formatted');

        $('.active-user--discount').css('display', 'flex');
    }

    showCartSummary(data, instance) {
        var checkout = JSON.parse(data);

        $.each(checkout.PromoItems, function () {
            this.SkuDisplay = this.Sku.substr(0, this.Sku.length - 1);
        });

        $.each(checkout.RebateItems, function () {
            this.SkuDisplay = this.Sku.substr(0, this.Sku.indexOf("_"));

            this.RebateType = "Kundtjänstrabatt";
            if (this.Sku.indexOf("_BB") > 0)
                this.RebateType = "Backbar";

            if (this.Sku.indexOf("_AB") > 0)
                this.RebateType = "Arbetsprodukt";
        });

        console.log(checkout);

        $(instance.cartResultSelector).html(instance.searchResultTemplate(checkout));

        if (checkout.CartItemErrors != null) {
            if (checkout.CartItemErrors.length > 0 && instance.cartErrorsTemplate) {
                $(instance.cartErrorsSelector).html(instance.cartErrorsTemplate(checkout));
                $('.checkout-cart-errors').show();
            }
            else {
                $('.checkout-cart-errors').hide();
            }
        }

        $('#cart-total').html(checkout.TotalCostExVAT);
        $('#cart-total').removeClass('formatted');

        $('#cart-freight-free').html(checkout.FreightFeeNeeded);
        $('#cart-freight-free').removeClass('formatted');

        if (checkout.FreightFeeExpressNeeded > -1) {
            $('#cart-freight-fee-express-wrapper').show();
            $('#cart-freight-free-express').html(checkout.FreightFeeExpressNeeded);
            $('#cart-freight-free-express').removeClass('formatted');
        } else {
            $('#cart-freight-fee-express-wrapper').hide();
        }

        if (!$('.cart').hasClass('active')) {
            $('.cart').addClass('flash');
        }

        setTimeout(instance.deactivateCart, 1000);

        instance.updateDiscounts(checkout, instance);

        instance.currencyFormatter.formatNumber();

        instance.bindCart(instance);

        instance.unlockCheckout();

        if (checkout.HasError) {
            bootbox.alert({
                title: "Ett problem uppstod",
                message: checkout.ErrorMessage
            });
        }

    }

    nShiftCallback(e) {
        let instance = this;
        instance.changeNShiftShipping(e, instance);
    }

    updateNShift(data, instance) {
        let toZip = $('.checkout-page').attr('data-zip');

        if (instance.enableMultipleDeliveryAddresses == "True") {
            toZip = $('#selected-zip').attr('data-zip');
        }

        let toMarket = $('.checkout-page').attr('data-marketid');
        let cartTotal = (data.TotalCostExVAT - data.TotalSumOfCourses);

        let config = {};
        config.language = "sv";
        config.useIcons = true;
        config.iconsInFront = true;
        config.iconsBaseUrl = "https://api.unifaun.com/rs-extapi/v1/delivery-checkouts-widget/logos";
        config.narrowDisplay = false;
        config.narrowBreakpointWidth = 760;
        config.narrowBreakpointWidth = 340;
        config.resultCallback = instance.nShiftCallback.bind(instance);
        config.installCSS = "nshift-v2";
        config.enableMap = true;

        let containerElement = document.getElementById("checkout-nshift");
        let widget = UnifaunCheckout.createAt(containerElement, config);
        let url = `/nshift/index?market=${toMarket}&zip=${toZip}&cartTotal=${cartTotal}`;
        widget.disable();
        fetch(url).then(function (response) {
            return response.json();
        }).then(function (data) {
            var parsedData = JSON.parse(data);
            widget.updateList(parsedData);

            $('.nshift-option').each(function (index, value) {
                $(this).attr("data-serviceId", parsedData.options[index].serviceId)
                $(this).attr("data-id", parsedData.options[index].id)

                var serviceId = $(this).data("serviceid")
                if (serviceId == "DELIVERYCHECKOUTAGENT") {
                    $(this).attr("data-serviceId", "BUDBIL_EXP")
                    $(this).children('.nshift-folding-block').hide()
                }

                if (serviceId == "DELIVERYCHECKOUTSERVICE") {
                    $(this).attr("data-serviceId", "NOLABLE")
                }
            })
            widget.updateList(parsedData);

            instance.nshiftWidgetFresh = true;
            instance.updatePaymentButtons(instance);
        }).catch(function () {
        }).then(function () {
            widget.enable();
        });
    }

    deactivateCart() {
        $('.cart').removeClass('flash');
    }
}